export function destroyElementNode(el, vNode) {
  const empty = document.createComment(' ');

  Object.defineProperty(empty, 'setAttribute', {
    value: () => undefined,
  });

  vNode.elm = empty;
  vNode.text = ' ';
  vNode.isempty = true;
  vNode.context = undefined;
  vNode.tag = undefined;
  vNode.data.directives = undefined;

  if (vNode.componentInstance) {
    vNode.componentInstance.$el = empty;
  }

  if (el.parentNode) {
    el.parentNode.replaceChild(empty, el);
  }
}

export function copyToClipboard(text) {
  return new Promise((resolve, reject) => {
    if (navigator.clipboard && window.isSecureContext) {
      // Modern Clipboard API (works with HTTPS)
      navigator.clipboard
        .writeText(text)
        .then(() => {
          resolve('Text copied to clipboard');
        })
        .catch((err) => {
          reject('Failed to copy text: ' + err);
        });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed'; // Prevents scrolling to bottom of page in some mobile browsers
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        const successful = document.execCommand('copy');
        if (successful) {
          resolve('Text copied to clipboard (fallback method)');
        } else {
          reject('Fallback: Unable to copy');
        }
      } catch (err) {
        reject('Fallback: Error trying to copy: ' + err);
      }
      document.body.removeChild(textArea);
    }
  });
}

export const formatBalance = (balance) => {
  const value = parseFloat(balance || 0) / 100;
  return formatNumber(value);
};

export const formatNumber = (num) => {
  const parts = parseFloat(num).toFixed(2).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  if (parts[1] === '00') return parts[0];
  return parts.join('.');
};

export const formatNumberToK = (number) => {
  if (number < 1000) return number.toString();

  const result = number / 1000;
  if (parseInt(result, 10) === result) return `${result}K`;
  return `${result.toFixed(1)}K`;
};

export const getDeviceType = () => {
  const ua = navigator.userAgent;
  if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Opera Mini/i.test(ua)) {
    return 'mobile';
  } else if (/iPad|Tablet|Nexus 7|Nexus 10|KFAPWI/i.test(ua)) {
    return 'tablet';
  }
  return 'desktop';
};

export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const scrollToTarget = (target, yOffsetPx) => {
  const element = typeof target === 'string' ? document.querySelector(target) : target;
  if (!element) return;
  const scrollToY = element.getBoundingClientRect().top + window.scrollY + yOffsetPx;
  window.scrollTo({ top: scrollToY, behavior: 'smooth' });
};

export const toKebabCase = (str) => {
  return str.toLowerCase().trim().replace(/\s+/g, '-'); // replace all spaces with hyphens
};

export const formatTimeLeft = (ms) => {
  if (!ms || ms <= 0) return '';
  
  const seconds = Math.floor(ms / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  const remainingHours = hours % 24;
  const remainingMinutes = minutes % 60;

  let result = '';
  if (days > 0) result += `${days}d `;
  if (remainingHours > 0 || days > 0) result += `${remainingHours}h `;
  result += `${remainingMinutes}m`;

  return result.trim();
};
